import { useQuery } from "react-query";

import { getAll } from "../../api/generic-api";
import { RQ } from "../../globals/enums";
import { QuickBooksTaxCode } from "../../models";

export const useQuickBooksTaxCodes = () => {
  return useQuery<QuickBooksTaxCode[], Error>(
    RQ.QUICK_BOOKS_TAX_CODES,
    () => getAll<QuickBooksTaxCode>("quick-books/tax-codes"),
    {
      enabled: false,
      staleTime: 5 * 60 * 1000,
    }
  );
};
